import { createSelector } from 'reselect';
import _first from 'lodash/first';
import { SIGN_OUT_SUCCESS } from 'modules/auth';


export const ACCOUNTS_LOADING = 'ACCOUNTS_LOADING';
export const ACCOUNTS_LOADED = 'ACCOUNTS_LOADED';


const defaultState = {
  isAccountsLoading: null,
  items: []
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACCOUNTS_LOADED:
      return { ...state, items: payload, isAccountsLoading: false };

    case ACCOUNTS_LOADING:
      return { ...state, isAccountsLoading: payload };

    case SIGN_OUT_SUCCESS:
      return {};

    default:
      return state
  }
}



export const accountsLoading = isLoading => ({ type: ACCOUNTS_LOADING, payload: isLoading })

export const accountsLoaded = payload => ({ type: ACCOUNTS_LOADED, payload })


// Selectors
export const getUserAccounts = state => state.accounts;

export const getFirstAccount = createSelector(
  getUserAccounts,
  accounts => _first(accounts.items || []) || null
);

export const isAccountsLoading = createSelector(
  getUserAccounts,
  accounts => accounts.isAccountsLoading
);



// WEBPACK FOOTER //
// ./src/modules/accounts/index.js